export default "__VITE_ASSET__DwhvIqUn__"